import { useState, useCallback } from 'react';

import { SiteManagementLocationFragment } from '@occc/graphql';
import { InfoDialog } from '@occc-app/design-system';

import LocationActivityDetails from './components/location-activity-details.component';
import { LocationActivityLog } from './components/location-activity-log.component';

type LocationLogProps = {
  location: SiteManagementLocationFragment;
};

type LocationLogDetails = object | null;

export const LocationLog = ({ location }: LocationLogProps) => {
  const [details, setDetails] = useState<LocationLogDetails>(null);

  const handleViewDetails = useCallback((details: LocationLogDetails) => {
    setDetails(details);
  }, []);

  const resetDetails = useCallback(() => {
    setDetails(null);
  }, []);

  return (
    <>
      <InfoDialog
        dialogTitle='Message Preview'
        onClose={resetDetails}
        open={!!details}
        maxWidth='md'
        transitionDuration={{ exit: 0 }}
      >
        <LocationActivityDetails
          title='Title Here'
          rawMessage='Data here'
          onClose={resetDetails}
          {...details}
        />
      </InfoDialog>
      <LocationActivityLog location={location} onRequestDetailsView={handleViewDetails} />
    </>
  );
};
